/**
 * Thrive's hosted legal pages. HealthOS serves no /legal/* routes of its
 * own; in-app links that pointed there fell through to the SPA router and
 * re-opened the sign-in flow (AUTH-5). Both URLs verified live.
 *
 * Shared rather than per-client: the web app, the extension and the Chrome Web
 * Store listing all have to name the same privacy policy, and the store treats
 * a listing whose policy does not match what the product does as grounds for
 * removal. One constant is the only way that stays true.
 */
export const THRIVE_PRIVACY_URL = "https://thriveglobal.com/privacy";
export const THRIVE_TERMS_URL = "https://thriveglobal.com/terms";
//# sourceMappingURL=legal-links.js.map